export const Divider = () => (
  <hr className="my-4 h-px border-0 bg-gray-200 dark:bg-gray-700" />
);
